<template>
<div>

  <div class="control is-horizontal">
    <div class="control-label">
      <label-name :labelKey="category && category.name == 'U4' ?  'APO-NEW_CONTENT_FIELD-U4' : 'APO-NEW_CONTENT_FIELD'"></label-name>
    </div>
    <div class="control">
      <textarea class="textarea is-medium" type="text" v-model="newContentField.content" :readonly="isReadOnly"></textarea>
    </div>
  </div>

  <div class="control is-horizontal">
    <div class="control-label"></div>
    <div class="control has-text-right" style="display: block;">
      <button :class="[{'is-disabled': isReadOnly}, 'button is-normal is-success is-pulled-right']" @click="addTextBox(categoryId)"><span class="icon is-small"><i class="icon-ak-speichern"></i></span>{{ $t('BTN-SAVE_TEXTBOX') }}</button>
    </div>
  </div>

  <div v-for="(contents, index) in catalogContentsReversed" :key="contents.id" class="control is-horizontal" v-if="contents.category == categoryId">

    <div class="control-label"></div>
    <div class="control">
      <textarea class="textarea is-medium" type="text" v-model="contents.content" :readonly="isReadOnly"></textarea>
    </div>
    <pop-confirm :content="$t('CONFIRMATIN-DELETE-ARE_YOU_SURE')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeTextBox(index) }">
      <button :class="[{'is-disabled': isReadOnly}, 'removeButton is-single button is-small is-light']" title="Klick um diesen Text zu löschen">
        <span class="icon is-tiny">
          <i class="icon-ak-entfernen-2"></i>
        </span>
      </button>
    </pop-confirm>

  </div>

</div>
</template>




<script>
export default {

  props: {

    categoryId: {
      type: Number,
      default: '',
      required: true
    },

    category: {
      type: Object,
      required: false
    },

    catalogContents: {
      type: Array,
      default: null
    },
    value: {
      type: Object,
      default: null
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }

  },

  data() {
    return {
      pageLayoutId: '',
      newContentField: {}
    }
  },

  computed: {

    catalogContentsReversed() {
      return this.catalogContents.slice().reverse();
    }

  },

  methods: {

    addTextBox: function(catId) {

      if (this.newContentField.content != undefined && this.newContentField.content.length >= 3) {
        this.newContentField.category = catId;
        this.newContentField.siteCatalog = this.value.id;
        this.$emit('addTextBox', this.newContentField);
        this.newContentField = {};
      } else {
        this.$notify.open({
          content: this.$t('MSG-COMMENT_MUST_HAVE_3_CHARS_AT_LEAST'),
          type: 'warning'
        });
      }

    },

    removeTextBox: function(index) {
      this.catalogContents.splice(this.catalogContents.length - index - 1, 1);
      this.$emit('removeTextBox', index);
      //this.$forceUpdate(); // force coputed property to update
    }
  },

}
</script>
